import { Outlet, useLocation } from 'react-router-dom'
import { Suspense, useEffect } from 'react'
import { Header } from '../layout/Header.tsx'
import styled from 'styled-components'
import { OptimizedPackageProvider } from './OptimizedPackageState.tsx'
import { InstallationRequestProvider } from '@/installationRequest/InstallationRequestState.tsx'
import { ErrorBoundary } from '@sentry/react'
import ErrorView from '@/uiComponents/ErrorView.tsx'
import { ResponsiveLayout } from '@/assets/style/mixins.ts'

const Main = styled.main`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - var(--header-height));
  min-height: calc(100dvh - var(--header-height));
  padding-top: 102px;
  ${ResponsiveLayout.queries};
`
export function SalesAssistantLayout() {
  const location = useLocation()

  useEffect(() => {
    document.title = 'Build your Ava package'
  }, [location])

  return (
    <>
      <Header />
      <Main>
        <ErrorBoundary fallback={<ErrorView />}>
          <OptimizedPackageProvider>
            <InstallationRequestProvider>
              <Suspense fallback={<div>Loading...</div>}>
                <Outlet />
              </Suspense>
            </InstallationRequestProvider>
          </OptimizedPackageProvider>
        </ErrorBoundary>
      </Main>
    </>
  )
}
